import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutPaymentMethodsComponentDef } from '@df/checkout/checkout-payment-methods.component.def';
import { ApplePayFilterPipe } from '@df/module-apple-pay/apple-pay-filter.pipe';
import { ApplePayService } from '@df/module-apple-pay/apple-pay.service';
import { IfKlarnaPaymentDirective } from '@df/module-klarna/if-klarna-payment.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { BraintreeHostedFieldsComponent } from '../module/braintree/hosted-fields/braintree-hosted-fields.component';
import { KlarnaPaymentComponent } from '../module/klarna/klarna-payment.component';
import { MollieCardsPaymentComponent } from '../module/mollie/cards/mollie-cards-payment.component';
import { StripeCardComponent } from '../module/stripe/stripe-card.component';
import { StripeSavedCardComponent } from '../module/stripe/stripe-saved-card.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio';
import { CheckoutFormComponent } from './checkout-form.component';
import { CheckoutStepComponent } from './checkout-step.component';
@Component({
    selector: 'checkout-payment-methods',
    templateUrl: './checkout-payment-methods.html',
    standalone: true,
    imports: [
        ApplePayFilterPipe,
        BraintreeHostedFieldsComponent,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        IfKlarnaPaymentDirective,
        KlarnaPaymentComponent,
        MollieCardsPaymentComponent,
        NgClass,
        NgFor,
        NgIf,
        NgSwitch,
        NgSwitch,
        NgSwitchCase,
        RadioComponent,
        RadioGroupDirective,
        StripeCardComponent,
        StripeSavedCardComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutPaymentMethodsComponent extends CheckoutPaymentMethodsComponentDef {
    protected MOLLIE_APPLE_PAY = 'mollie_methods_applepay';
    /**
     * Class constructor
     */
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        checkoutStepComponent: CheckoutStepComponent,
        changeDetectorRef: ChangeDetectorRef,
        private applePayService: ApplePayService
    ) {
        super(checkoutFormComponent, checkoutStepComponent, changeDetectorRef);
    }

    protected override validateSelectedMethod(): void {
        super.validateSelectedMethod();
        if (
            this.data.method === this.MOLLIE_APPLE_PAY &&
            (!this.applePayService.isAvailable || !this.applePayService.isSupportedVersion(3))
        ) {
            this.data.method = undefined;
        }
    }

    protected get disabled(): boolean {
        return this.saveStatus.busy;
    }
}
